import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import PurchaseOrderForm from './PurchaseOrdersForm';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DarkHeaderModal = styled(Modal)`
  & {
    width: 70% !important;

    @media (max-width: 1615px) {
      width: 80% !important;
    }

    @media (max-width: 1366px) {
      width: 90% !important;
    }

    @media (max-width: 1024px) {
      width: 95% !important;
    }

    @media (max-width: 768px) {
      width: 95% !important;
    }
  }

  .ant-modal-content {
    .ant-modal-close {
      .ant-modal-close-x {
        color: #05103a;
      }
    }

    .ant-modal-header {
      border-bottom: 0;

      .ant-modal-title {
        color: #05103a;
      }
    }

    .ant-modal-body {
      padding: 12px 18px;
    }
  }

  .footer-row {
    margin-top: 21px;
  }

  .save-btn {
    margin-left: 8px;
  }
`;

const PurchaseOrderAddModal = ({ visible, onCancel, onSave }) => {
  const [randomNumber, setRandomNumber] = useState(null);

  useEffect(() => {
    setRandomNumber(Math.floor(100000 + Math.random() * 900000));
  }, [visible]);

  return (
    <DarkHeaderModal
      title="Add Purchase Order"
      open={visible}
      onCancel={onCancel}
      footer={null}
      style={{ top: 20 }}
    >
      <PurchaseOrderForm
        childRef={() => {}}
        purchaseOrder={{
          purchase_order_number: randomNumber,
        }}
        onSave={onSave}
        onCancel={onCancel}
        isNew={true}
        hideSelectFleet={true}
      />
    </DarkHeaderModal>
  );
};

PurchaseOrderAddModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
};

export default PurchaseOrderAddModal;
